var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ValidationProvider',{attrs:{"vid":_vm.vid,"name":_vm.$attrs.label,"rules":_vm.rules},scopedSlots:_vm._u([{key:"default",fn:function({errors}){return [_c('v-select',_vm._g(_vm._b({attrs:{"dense":"","color":"primary","error-messages":errors}},'v-select',_vm.$attrs,false),_vm.$listeners))]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }